// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.avatar-sm[data-v-5b8b9a68] {\n  width: 56px;\n  border-radius: 50%;\n}\n.chat-message-type[data-v-5b8b9a68] {\n  flex: 1 0 auto !important;\n}\n  \n  ", ""]);
// Exports
module.exports = exports;
